import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90 dark:bg-[#82aaff] dark:text-[#011627] dark:hover:bg-[#6d94e8]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 dark:bg-[#ff5874] dark:text-white dark:hover:bg-[#e64d67]",
        outline:
          "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground dark:border-[#1d3b53] dark:text-[#d6deeb] dark:hover:bg-[#1d3b53]/50",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80 dark:bg-[#1d3b53] dark:text-[#d6deeb] dark:hover:bg-[#234e6e]",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-[#1d3b53]/50 dark:hover:text-[#d6deeb]",
        link: "text-primary underline-offset-4 hover:underline dark:text-[#82aaff]",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
